/**
 * Convertit une chaîne "hh:mm:ss,ms" en secondes.
 * Exemple : "00:01:02,500" → 62.5 secondes
 */
function parseTime(timeString) {
	const [time, ms] = timeString.split(',');
	const [hours, minutes, seconds] = time.split(':').map(Number);
	return hours * 3600 + minutes * 60 + seconds + parseInt(ms, 10) / 1000;
}

/**
 * Parse le contenu d’un fichier SRT en un tableau d’objets.
 * Chaque objet contient : startTime, endTime et text.
 */
function parseSRT(data) {
	const subtitles = [];
	// Découpage par blocs (séparés par deux retours à la ligne)
	const blocks = data.split(/\r?\n\r?\n/);
	blocks.forEach((block) => {
		const lines = block.trim().split(/\r?\n/);
		if (lines.length >= 3) {
			const timeRange = lines[1];
			const [startTimeStr, endTimeStr] = timeRange.split(' --> ');
			const startTime = parseTime(startTimeStr);
			const endTime = parseTime(endTimeStr);
			const text = lines.slice(2).join('\n');
			subtitles.push({ startTime, endTime, text });
		}
	});
	return subtitles;
}

export { parseSRT };
